(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/router/assets/javascripts/mcl-route.js') >= 0) return;  svs.modules.push('/components/app/router/assets/javascripts/mcl-route.js');
"use strict";

const _excluded = ["componentName", "componentProps", "getComponent", "onError", "onLoading"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


const loadModuleComponent = svs.core.module.loadModuleComponent;
const useEffect = React.useEffect;
const useState = React.useState;
const Route = ReactRouterDOM.Route;
const logger = new svs.core.log.Logger('app:route:mcl-route');
const useMcl = _ref => {
  let {
    componentName,
    getComponent,
    componentProps,
    onError,
    onLoading
  } = _ref;
  const [error, setError] = useState();
  const [Component, setComponent] = useState();
  const [componentBundle, setComponentBundle] = useState({
    componentProps: null,
    onError: null,
    onLoading: null
  });
  const safeGetComponent = () => {
    try {
      return getComponent();
    } catch (e) {
      return undefined;
    }
  };
  useEffect(() => {
    setComponent(safeGetComponent);
    setComponentBundle({
      componentProps,
      onError,
      onLoading
    });
  }, [getComponent]); 

  useEffect(() => {
    let wasCancelled = false;
    if (!Component) {
      loadModuleComponent(componentName, err => {
        if (!wasCancelled) {
          if (err) {
            logger.error('Error loading module component', err);
            setError(err);
          } else {
            setComponent(safeGetComponent);
          }
        }
      });
    }
    return () => {
      wasCancelled = true;
    };
  }, [Component]);
  return [componentBundle.onError, componentBundle.onLoading, componentBundle.componentProps, error, Component];
};
const LoadMCl = props => {
  const [onError, onLoading, componentProps, error, Component] = useMcl(props);
  if (error && onError) {
    props.onError(error);
    return null;
  }
  if (!Component && onLoading) {
    props.onLoading();
    return null;
  }
  return Component ? React.createElement(Component, componentProps) : null;
};
const MclRoute = props => {
  const {
      componentName,
      componentProps,
      getComponent,
      onError,
      onLoading
    } = props,
    routeProps = _objectWithoutProperties(props, _excluded);
  return React.createElement(Route, _extends({}, routeProps, {
    render: () => React.createElement(LoadMCl, {
      componentName: componentName,
      componentProps: componentProps,
      getComponent: getComponent,
      onError: onError,
      onLoading: onLoading
    })
  }));
};
svs.app.ReactRouter.useMcl = useMcl;
svs.app.ReactRouter.MclRoute = MclRoute;

 })(window);